import { DialogPopupProps, SelectOption } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
import { AlertType } from 'react-alert'
import { Api, User } from 'services'
// import { RootStore } from 'mobx-stores/root-store'
import { Alert } from './general-store.types'
import { UserRoleDTO } from 'models'

export class GeneralStore {
  private rootStore: any
  public api: Api

  constructor (rootStore: any) {
    this.rootStore = rootStore
    this.api = new Api(this)
    makeAutoObservable(this)
  }

  // ALERT
  public alert: Alert = { type: 'info', message: '', counter: 0 }

  public handleApiError = (error: Error) => {
    try {
      const err = JSON.parse(error.message)
      console.error(err)
      if(this.alert.counter >= 1) return; // Prevent multiple popups

      /** Handle Shopify Error Manually */
      if(err?.errors) this.showError(err.errors)

      if (err.status && err.status === 401) {
        User.deauthenticate()
        this.rootStore.routingStore.replace('/login')
        this.clearStores()
        this.showError(err.message || 'Something went wrong')
      }else{
        this.showError(err.message || 'Something went wrong')
      }
    } catch (runError) {
      console.error('RUN ERROR', runError)
      this.showError('Failed to fetch')
    }
  }

  private showAlert = (type: AlertType, message: string): void => {
    this.alert = {
      type,
      message,
      counter: this.alert.counter + 1
    }
  }

  public showError = (message: string): void => {
    this.showAlert('error', message)
  }

  public showInfo = (message: string): void => {
    this.showAlert('info', message)
  }

  public showSuccess = (message: string): void => {
    this.showAlert('success', message)
  }

  // LOADING
  public loading: boolean = false

  private changeLoadingValue = (values: boolean) => {
    this.loading = values
  }

  public setLoadingOn = (): void => {
    this.changeLoadingValue(true)
  }

  public setLoadingOff = (): void => {
    this.changeLoadingValue(false)
  }

  // DIALOG POPUP
  public dialogPopupProps: Partial<DialogPopupProps> = null

  public openDialogPopup = (props: Partial<DialogPopupProps>): void => {
    this.dialogPopupProps = props
  }

  public closeDialogPopup = (): void => {
    this.dialogPopupProps = null
  }

  // USER ROLES
  private userRoles: UserRoleDTO[] = null

  private setUserRoles = (roles: UserRoleDTO[]): void => {
    this.userRoles = roles
  }

  public loadUserRoles = async (): Promise<void> => {
    const userRolesAreLoaded = this.userRoles !== null
    if (userRolesAreLoaded) return
    const roles = await this.api.userApi.getUserRoles()
    if (!roles) return
    this.setUserRoles(roles)
  }

  public get userRoleSelectOptions (): SelectOption<UserRoleDTO>[] {
    if (!this.userRoles?.length) return []
    return this.userRoles.map(role => ({
      label: role.label,
      value: role
    }))
  }

  // METHODS
  private clearStores = (): void => {
    this.setUserRoles(null)
    this.rootStore.addUserPageStore.clearStore()
    this.rootStore.userProfilePageStore.clearStore()
    this.rootStore.addStorePageStore.clearStore()
    this.rootStore.usersMainStore.clearStore()
    this.rootStore.userSearchStore.clearStore()
  }
}
